
<template>
          <div class="flex_option">
            <span v-for="opt in  option" :key="opt.id">
                <b-tooltip :label="opt.name"
            type="is-dark"
            position="is-right">
              <img :data-src="opt.icon" uk-img :alt="opt.name">
        </b-tooltip>  
            </span>
          </div>
</template>

<script>
export default {
   name:'block_option',
   props:['option']
}
</script>

<style lang="scss" scoped>
  .flex_option{
    display: flex;
    align-items: center;
    width: 50%;
  flex-wrap: wrap;
  justify-content: flex-end;
  span{
    display: block;
   width: 22px;
    height: 22px;
    margin-right: 8px;
    margin-bottom: 5px;
    img{
      transition: 0.3s ease-in-out;
            filter: grayscale(300%) brightness(70%) sepia(100%) hue-rotate(8deg) saturate(500%) contrast(1);
    }
  }
  }
@media (max-width: 787px) {
  .flex_allergi , .flex_option{
  span{
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
}
}
</style>